export default "__VITE_ASSET__MM70WyKk__"